import { render } from "./EmptyCart.vue?vue&type=template&id=311cb2f4&scoped=true"
const script = {}

import "./EmptyCart.vue?vue&type=style&index=0&id=311cb2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311cb2f4"]])

export default __exports__